module.exports = __webpack_public_path__ + "static/media/41.d0dcd8fe.wav";